import React, { useEffect, useState } from 'react';
import Header from "components/Header/Header.js";
import HomeFooter from "components/Footer/HomeFooter.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import { colors } from '../components/Theme/WebTheme';
import { Box, Grid, Typography, Button } from '@mui/material';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import SpeedIcon from '@mui/icons-material/Speed';
import SecurityIcon from '@mui/icons-material/Security';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FONT_FAMILY } from 'common/sharedFunctions';
import { useNavigate } from 'react-router-dom';
import heroBg from '../assets/img/web_bg2.png';
import HandsOnMobile from '../assets/img/handroadphone2.png';

const dashboardRoutes = [];

export default function LandingPage(props) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const cartypes = useSelector(state => state.cartypes);
  const navigate = useNavigate();
  const { ...rest } = props;

  const [role, setRole] = useState();
  const [loggedIn, setLoggedIn] = useState(false);

  const scrollToDownload = () => {
    document.getElementById('download-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const isAdminOrDriver = loggedIn && (role === 'admin' || role === 'fleetadmin' || role === 'driver');
  const [carData, setCarData] = useState([]);

  useEffect(() => {
    if (auth && auth.profile && auth.profile.uid) {
      setRole(auth.profile.usertype);
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
  }, [auth]);

  useEffect(() => {
    if (cartypes.cars && settings) {
      setCarData(
        cartypes.cars
          .filter(car => car.category === settings.appCat)
          .sort((a, b) => a.pos - b.pos)
      );
    }
  }, [cartypes.cars, settings]);

  const features = [
    {
      icon: <SmartphoneIcon sx={{ fontSize: 44, color: '#ffce00' }} />,
      title: 'Réservation en un clic',
      desc: 'Commandez votre course directement depuis votre smartphone en quelques secondes.',
    },
    {
      icon: <SpeedIcon sx={{ fontSize: 44, color: '#ffce00' }} />,
      title: 'Rapidité & Ponctualité',
      desc: 'Nos chauffeurs professionnels arrivent en temps record, où que vous soyez.',
    },
    {
      icon: <SecurityIcon sx={{ fontSize: 44, color: '#ffce00' }} />,
      title: 'Sécurité garantie',
      desc: 'Véhicules vérifiés, chauffeurs certifiés. Votre sécurité est notre priorité.',
    },
    {
      icon: <SupportAgentIcon sx={{ fontSize: 44, color: '#ffce00' }} />,
      title: 'Support 24h/24',
      desc: 'Notre équipe est disponible à toute heure pour vous accompagner.',
    },
  ];

  return (
    <div style={{ backgroundColor: colors.LandingPage_Background, margin: '-8px', overflowX: 'hidden', direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
      {/* ── HEADER ── */}
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{ height: 400, color: 'white' }}
        {...rest}
      />

      {/* ── HERO ── */}
      <Box
        sx={{
          width: '100%',
          minHeight: '100vh',
          backgroundImage: `url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        {/* Overlay sombre */}
        <Box sx={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(135deg, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.38) 100%)',
        }} />

        <Box sx={{ position: 'relative', zIndex: 1, textAlign: 'center', px: { xs: 2, sm: 3 }, maxWidth: 750, width: '100%' }}>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <img
              src={require('../assets/img/yellowl.png')}
              alt="Mwendo"
              style={{ width: 140, height: 140, objectFit: 'contain', marginBottom: 16 }}
            />
          </Box>
          <Typography
            variant="h2"
            fontWeight={800}
            fontFamily={FONT_FAMILY}
            sx={{ color: '#ffce00', mb: 2, fontSize: { xs: '1.7rem', sm: '2.2rem', md: '3.2rem' } }}
          >
            Votre transport, simplifié.
          </Typography>
          <Typography
            variant="h6"
            fontFamily={FONT_FAMILY}
            sx={{ color: 'rgba(255,255,255,0.88)', mb: 4, lineHeight: 1.7, fontSize: { xs: '0.95rem', sm: '1.1rem', md: '1.25rem' } }}
          >
            Mwendo vous connecte à des chauffeurs professionnels en quelques secondes.
            Disponible partout au Gabon, 7j/7 et 24h/24.
          </Typography>

          {/* Boutons téléchargement */}
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap', mb: 3 }}>
            {settings && settings.PlayStoreLink && (
              <a href={settings.PlayStoreLink} target="_blank" rel="noreferrer">
                <img src={require('../assets/img/playstore.png')} alt="Google Play" style={{ height: 52 }} />
              </a>
            )}
            {settings && settings.AppleStoreLink && (
              <a href={settings.AppleStoreLink} target="_blank" rel="noreferrer">
                <img src={require('../assets/img/appstore.png')} alt="App Store" style={{ height: 52 }} />
              </a>
            )}
          </Box>

          <Button
            variant="outlined"
            size="large"
            fontFamily={FONT_FAMILY}
            onClick={() => isAdminOrDriver
              ? navigate(role === 'driver' ? '/bookings' : '/addbookings')
              : scrollToDownload()
            }
            sx={{
              borderColor: '#ffce00', color: '#ffce00', fontFamily: FONT_FAMILY, fontWeight: 700,
              px: 4, py: 1.2, fontSize: '1rem',
              '&:hover': { backgroundColor: '#ffce00', color: '#000', borderColor: '#ffce00' }
            }}
          >
            {isAdminOrDriver ? t('book_your_ride_menu') : 'Télécharger l\'application →'}
          </Button>
        </Box>
      </Box>

      {/* ── AVANTAGES ── */}
      <Box sx={{ backgroundColor: '#1A1D2E', py: { xs: 6, md: 9 }, px: { xs: 2, sm: 3 } }}>
        <Typography
          variant="h4" fontWeight={700} fontFamily={FONT_FAMILY}
          sx={{ textAlign: 'center', color: '#ffce00', mb: { xs: 4, md: 6 }, fontSize: { xs: '1.6rem', md: '2.125rem' } }}
        >
          Pourquoi choisir Mwendo ?
        </Typography>
        <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
        <Grid container spacing={{ xs: 2, sm: 3, md: 4 }} justifyContent="center">
          {features.map((f, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Box sx={{
                backgroundColor: '#22263a', borderRadius: 3, p: { xs: 3, md: 4 }, textAlign: 'center',
                height: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.25)',
                transition: 'transform 0.2s', '&:hover': { transform: 'translateY(-6px)' }
              }}>
                {f.icon}
                <Typography variant="h6" fontWeight={700} fontFamily={FONT_FAMILY} sx={{ color: '#fff', mt: 2, mb: 1 }}>
                  {f.title}
                </Typography>
                <Typography fontFamily={FONT_FAMILY} sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.95rem' }}>
                  {f.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        </Box>
      </Box>

      {/* ── TYPES DE VÉHICULES ── */}
      {carData.length > 0 && (
        <Box sx={{ backgroundColor: '#f5f5f5', py: { xs: 6, md: 9 }, px: { xs: 2, sm: 3 } }}>
          <Typography
            variant="h4" fontWeight={700} fontFamily={FONT_FAMILY}
            sx={{ textAlign: 'center', color: '#1A1D2E', mb: 1, fontSize: { xs: '1.6rem', md: '2.125rem' } }}
          >
            Nos véhicules
          </Typography>
          <Typography fontFamily={FONT_FAMILY} sx={{ textAlign: 'center', color: '#555', mb: { xs: 4, md: 6 }, fontSize: { xs: '0.95rem', md: '1.05rem' } }}>
            Choisissez la catégorie qui correspond à vos besoins
          </Typography>
          <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
          <Grid container spacing={{ xs: 2, md: 3 }} justifyContent="center">
            {carData.map((item, key) => (
              <Grid item xs={12} sm={6} md={4} key={key}>
                <Box sx={{
                  backgroundColor: key % 2 === 0 ? colors.CAR_BOX_EVEN : colors.CAR_BOX_ODD,
                  borderRadius: 3, p: 4, textAlign: 'center',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
                  transition: 'transform 0.2s', '&:hover': { transform: 'translateY(-5px)' }
                }}>
                  <img alt={item.name} src={item.image} style={{ width: 160, height: 90, objectFit: 'contain' }} />
                  <Typography variant="h6" fontWeight={700} fontFamily={FONT_FAMILY} sx={{ mt: 2, mb: 1, color: '#1A1D2E' }}>
                    {item.name}
                  </Typography>
                  <Box sx={{ backgroundColor: '#fff', borderRadius: 2, p: 2, boxShadow: 1 }}>
                    <Typography fontFamily={FONT_FAMILY} sx={{ fontWeight: 'bold', fontSize: '1.3rem', color: '#1A1D2E' }}>
                      {settings?.swipe_symbol === false
                        ? `${settings?.symbol} ${item.rate_per_unit_distance}/${settings?.convert_to_mile ? t('mile') : t('km')}`
                        : `${item.rate_per_unit_distance} ${settings?.symbol}/${settings?.convert_to_mile ? t('mile') : t('km')}`}
                    </Typography>
                    <Typography fontFamily={FONT_FAMILY} sx={{ color: '#666', fontSize: '0.9rem', mt: 0.5 }}>
                      Tarif mini : {item.min_fare} {settings?.symbol}
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    onClick={() => isAdminOrDriver
                      ? navigate(role === 'driver' ? '/bookings' : '/addbookings', { state: { carData: item } })
                      : scrollToDownload()
                    }
                    sx={{
                      mt: 2, backgroundColor: '#1A1D2E', color: '#ffce00', fontFamily: FONT_FAMILY, fontWeight: 700,
                      '&:hover': { backgroundColor: '#ffce00', color: '#1A1D2E' }
                    }}
                  >
                    {isAdminOrDriver ? (role === 'driver' ? t('info') : t('book_now')) : 'Télécharger'}
                  </Button>
                </Box>
              </Grid>
            ))}
          </Grid>
          </Box>
        </Box>
      )}

      {/* ── COMMENT ÇA MARCHE ── */}
      <Box sx={{ backgroundColor: '#fff', py: { xs: 6, md: 9 }, px: { xs: 2, sm: 3 } }}>
        <Typography variant="h4" fontWeight={700} fontFamily={FONT_FAMILY} sx={{ textAlign: 'center', color: '#1A1D2E', mb: { xs: 4, md: 6 }, fontSize: { xs: '1.6rem', md: '2.125rem' } }}>
          Comment ça marche ?
        </Typography>
        <Box sx={{ maxWidth: 900, mx: 'auto' }}>
        <Grid container spacing={{ xs: 3, md: 4 }} justifyContent="center">
          {[
            { num: '01', title: 'Téléchargez l\'application', desc: 'Disponible gratuitement sur Google Play et l\'App Store.' },
            { num: '02', title: 'Créez votre compte', desc: 'Inscription rapide en moins de 2 minutes avec votre numéro de téléphone.' },
            { num: '03', title: 'Réservez votre course', desc: 'Entrez votre destination et un chauffeur arrive en quelques minutes.' },
          ].map((step, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Box sx={{ textAlign: 'center', px: 2 }}>
                <Box sx={{
                  width: 72, height: 72, borderRadius: '50%', backgroundColor: '#ffce00',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 2
                }}>
                  <Typography fontWeight={900} fontSize="1.4rem" fontFamily={FONT_FAMILY} color="#1A1D2E">{step.num}</Typography>
                </Box>
                <Typography variant="h6" fontWeight={700} fontFamily={FONT_FAMILY} sx={{ mb: 1, color: '#1A1D2E' }}>{step.title}</Typography>
                <Typography fontFamily={FONT_FAMILY} sx={{ color: '#666' }}>{step.desc}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        </Box>
      </Box>

      {/* ── DOWNLOAD CTA ── */}
      <Box id="download-section" sx={{
        background: 'linear-gradient(135deg, #1A1D2E 0%, #2d3250 100%)',
        py: 9, px: { xs: 2, sm: 3 }
      }}>
        <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
        <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={5} sx={{ display: 'flex', justifyContent: 'center' }}>
            <img
              src={HandsOnMobile}
              alt="Téléchargez Mwendo"
              style={{ width: '100%', maxWidth: 420, borderRadius: 16, boxShadow: '0 8px 40px rgba(0,0,0,0.4)' }}
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', md: 'flex-start' }, mb: 2 }}>
              <EmojiTransportationIcon sx={{ fontSize: 36, color: '#ffce00', mr: 1 }} />
              <Typography variant="overline" fontFamily={FONT_FAMILY} sx={{ color: '#ffce00', letterSpacing: 3 }}>
                Application mobile
              </Typography>
            </Box>
            <Typography variant="h3" fontWeight={800} fontFamily={FONT_FAMILY} sx={{ color: '#fff', mb: 2, lineHeight: 1.2, fontSize: { xs: '1.8rem', sm: '2.4rem', md: '3rem' } }}>
              Téléchargez<br />
              <span style={{ color: '#ffce00' }}>Mwendo</span> dès maintenant
            </Typography>
            <Typography fontFamily={FONT_FAMILY} sx={{ color: 'rgba(255,255,255,0.7)', mb: 4, fontSize: { xs: '0.95rem', md: '1.1rem' }, lineHeight: 1.8 }}>
              Rejoignez des milliers d'utilisateurs au Gabon qui font confiance à Mwendo pour
              leurs déplacements quotidiens. Simple, rapide, sécurisé.
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: { xs: 'center', md: 'flex-start' } }}>
              {settings && settings.PlayStoreLink ? (
                <a href={settings.PlayStoreLink} target="_blank" rel="noreferrer">
                  <img src={require('../assets/img/playstore.png')} alt="Google Play" style={{ height: 56 }} />
                </a>
              ) : (
                <Box sx={{
                  height: 56, px: 3, backgroundColor: '#111', borderRadius: 2,
                  display: 'flex', alignItems: 'center', border: '1px solid rgba(255,255,255,0.2)'
                }}>
                  <Typography fontFamily={FONT_FAMILY} sx={{ color: '#fff', fontSize: '0.9rem' }}>Google Play — Bientôt</Typography>
                </Box>
              )}
              {settings && settings.AppleStoreLink ? (
                <a href={settings.AppleStoreLink} target="_blank" rel="noreferrer">
                  <img src={require('../assets/img/appstore.png')} alt="App Store" style={{ height: 56 }} />
                </a>
              ) : (
                <Box sx={{
                  height: 56, px: 3, backgroundColor: '#111', borderRadius: 2,
                  display: 'flex', alignItems: 'center', border: '1px solid rgba(255,255,255,0.2)'
                }}>
                  <Typography fontFamily={FONT_FAMILY} sx={{ color: '#fff', fontSize: '0.9rem' }}>App Store — Bientôt</Typography>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
        </Box>
      </Box>

      {/* ── FOOTER ── */}
      <HomeFooter />
    </div>
  );
}
